// extracted by mini-css-extract-plugin
module.exports = {"ds9LoadingIcon":"Loader_ds9LoadingIcon__7S5YG","fade":"Loader_fade__FF0bZ","ds9LoadingIconSpinner":"Loader_ds9LoadingIconSpinner__sLY9A","spin":"Loader_spin__j5onJ"};